import { imageData } from "DTO/userWorkOrderListDto";
import { HorizontalFlex } from "../pandora/styled";
import { downloadFileClick } from "Utils/Utils";
import { Button } from "@mui/material";

export type Image = {
  selectedUserImage: { url: string }[];
};

export interface DisplayImagesProps {
  setIsOpen: (b: boolean) => void;
  setImageIndex: (n: number) => void;
  imageProps: imageData[] | [];
  setError: (b: boolean) => void;
  setErrorMessage: (s: string) => void;
}

export default function DisplayImages({
  setIsOpen,
  setImageIndex,
  imageProps,
  setError,
  setErrorMessage,
}: Readonly<DisplayImagesProps>) {
  const downloadFiles = async (files: string[]) => {
    for (const file of files) {
      await new Promise<void>((resolve) => {
        downloadFileClick(
          file,
          () => {
            setErrorMessage("Error While Requesting File!");
            setError(true);
          },
          true
        );
        setTimeout(() => {
          resolve();
        }, 100);
      });
    }
  };

  return (
    <HorizontalFlex
      css={
        "flex-Wrap: wrap; justify-content: space-between; overflow-x: scroll; max-height: 80vh;"
      }
    >
      {imageProps?.length > 0 && (
        <Button
          style={{ width: "100%", border: "1px solid", margin: "6px 0 6px 0" }}
          onClick={() =>
            downloadFiles(imageProps.map((i: { url: string }) => i.url))
          }
        >
          {" "}
          Ladda ner alla bilder
        </Button>
      )}

      {imageProps && imageProps?.length ? (
        imageProps?.map((data, index) => {
          const { url } = data;
          return (
            <HorizontalFlex
              key={index}
              onClick={() => {
                setIsOpen(true);
                setImageIndex(index);
              }}
              css="cursor: pointer"
            >
              <img
                src={
                  url
                    ? url
                    : `https://img.icons8.com/pastel-glyph/64/000000/error.png`
                }
                style={{
                  margin: 5,
                  maxHeight: 400,
                  width: "auto",
                }}
                alt="image_could_not_load"
              />
            </HorizontalFlex>
          );
        })
      ) : (
        <HorizontalFlex css={"font-size: 11px;"}>Inga bilder</HorizontalFlex>
      )}
    </HorizontalFlex>
  );
}
